import React from "react";
import { Box, BoxProps, styled } from "@mui/material";
import { Padding } from "@mui/icons-material";

interface MainLayoutProps {
    children: React.ReactNode;
}

// Wrapper utama untuk layout tanpa sidebar
const BlankLayoutWrapper = styled(Box)<BoxProps>(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: "100%",
    backgroundColor: '#f0f0f0ff',

    // pastikan wrapper tidak memberi padding/width yang tidak perlu
    "& .app-content": {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        overflowX: "hidden",
    },

    // helper class untuk content block agar mudah dipakai di page
    "& .public-container": {
        width: "100%",
        display: "flex",
        justifyContent: "center", /* center horizontally */
        alignItems: "flex-start",
        padding: theme.spacing(0),
        boxSizing: "border-box",
    },

}));

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    return (
        <BlankLayoutWrapper className="layout-wrapper">
            <Box className="app-content">
                <div className="public-container">
                    {children}
                </div>
            </Box>
        </BlankLayoutWrapper>
    );
};

export default MainLayout;
